import React from 'react'
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import { bool } from 'prop-types'

import EmailCampaigns from 'applications/EmailCampaigns'
import Dashboard from 'applications/Dashboard'
import Track from 'applications/Track'

import MarketingBanner from 'sharedComponents/MarketingBanner'
import Footer from 'sharedComponents/Footer'


const InkfrogRouter = ({ admin } ) => (
  <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <div>
      <div id="sub-analytics-body" className="third-party">
        <MarketingBanner />
        <Routes>
          <Route path="/emailcampaigns/*" element={<EmailCampaigns />} />
          <Route path="/dashboard/*" element={<Dashboard />} />
          <Route path="/track/*" element={<Track />} />
          <Route path="/staff/*" element={admin ? <Navigate to="/admin/users" replace /> : null} />
          <Route path="/statistics/*" element={admin ? <Navigate to="/admin/operations" replace /> : null} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </div>
      <footer id="sub-analytics-footer" className="third-party">
        <Footer />
      </footer>
    </div>
  </Router>
)

InkfrogRouter.propTypes = {
  admin: bool,
}

export default InkfrogRouter
